import { IPatient } from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';
import { IBaseCommand, IBridgeIntegration } from '../../send-command-to-device';

export const ROMEXIS_V2_INTEGRATION: IBridgeIntegration = {
  label: 'Romexis (V2)',
  description:
    'Two-way integration with Planmeca Romexis: opens patient files and ' +
    'automatically imports captured images from the Romexis database',
};

export type RomexisV2ResolvePatientCommand = IBaseCommand<
  RomexisV2ToDeviceCommand.ResolvePatient,
  {
    patient: WithRef<IPatient>;
    targetDeviceId: string;
  }
>;

export interface IRomexisV2LaunchArgs {
  patientId: string;
  firstName: string;
  lastName: string;
  birthdate: string;
}

export type RomexisV2LaunchPatientCommand = IBaseCommand<
  RomexisV2ToDeviceCommand.LaunchPatient,
  IRomexisV2LaunchArgs
>;

export enum RomexisV2ToDeviceCommand {
  ResolvePatient = 'romexisV2.resolvePatient',
  LaunchPatient = 'romexisV2.launchPatient',
}

export interface IRomexisV2ResolvedPatientCommand extends IRomexisV2LaunchArgs {
  targetDeviceId: string;
}
